var _mask, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.6,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_33_4952",
    maskUnits: "userSpaceOnUse",
    x: 8.5,
    y: 6.5,
    width: 7,
    height: 11
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 8.5,
    y: 6.5,
    width: 7,
    height: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3673 11.6788L10.2835 7.63286C10.1044 7.45571 9.81404 7.45571 9.63439 7.63286C9.4552 7.81 9.4552 8.09773 9.63439 8.27487L13.3942 11.9998L9.63485 15.7247C9.45565 15.9018 9.45565 16.1896 9.63485 16.3671C9.81404 16.5443 10.1048 16.5443 10.284 16.3671L14.3677 12.3212C14.5442 12.1459 14.5442 11.8537 14.3673 11.6788Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3673 11.6788L10.2835 7.63286C10.1044 7.45571 9.81404 7.45571 9.63439 7.63286C9.4552 7.81 9.4552 8.09773 9.63439 8.27487L13.3942 11.9998L9.63485 15.7247C9.45565 15.9018 9.45565 16.1896 9.63485 16.3671C9.81404 16.5443 10.1048 16.5443 10.284 16.3671L14.3677 12.3212C14.5442 12.1459 14.5442 11.8537 14.3673 11.6788Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3673 11.6788L10.2835 7.63286C10.1044 7.45571 9.81404 7.45571 9.63439 7.63286C9.4552 7.81 9.4552 8.09773 9.63439 8.27487L13.3942 11.9998L9.63485 15.7247C9.45565 15.9018 9.45565 16.1896 9.63485 16.3671C9.81404 16.5443 10.1048 16.5443 10.284 16.3671L14.3677 12.3212C14.5442 12.1459 14.5442 11.8537 14.3673 11.6788Z",
    strokeWidth: 0.6,
    mask: "url(#path-1-outside-1_33_4952)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevronRight.15b5c0bf44dea285173cedd4f423c0da.svg";
export { ForwardRef as ReactComponent };